import React, { useRef } from 'react'
import styles from './Case.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Case: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.case} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.ctsTitle}>導入事例</h2>
        <p className={styles.reedText}>
          Aitriaは、金融・IT/情報通信・小売/流通・人材など幅広い業界で、戦略設計からUX/UI開発、グロース運用までを支援しています。単なる受託開発ではなく、クライアントと共に事業を成長させる“共創型アプローチ”で成果を創出しています。
        </p>
        <div className={styles.caseWrapper}>
          <div className={styles.caseWrapper__one}>
            <div className={`${styles.caseItem} ${styles.item01}`}>
              <a href="/cases/career-design-center/" className={styles.caseItem__link}>
                <p className={styles.caseItem__num}>Case 01</p>
                <div className={styles.caseItem__layout}>
                  <figure className={styles.caseItem__layout__left}>
                    <img
                      src="/img/LP/mobile-app-development/case01_cdc.webp"
                      alt="利用者10％増- UX/UI改善で転職成功に必須のアプリを開発"
                    />
                  </figure>
                  <div className={styles.caseItem__layout__right}>
                    <p className={styles.caseItem__layout__right__tag}>人材サービス業界</p>
                    <h2 className={styles.caseItem__layout__right__title}>
                      利用者10％増- UX/UI改善で転職成功に必須のアプリを開発
                    </h2>
                    <p className={styles.caseItem__layout__right__name}>株式会社キャリアデザインセンター</p>
                    <dl className={styles.caseItem__layout__right__result}>
                      <dt className={styles.caseItem__layout__right__result__title}>プロジェクトの成果</dt>
                      <dd className={styles.caseItem__layout__right__result__text}>
                        アプリストアの評価が大幅に向上<span> (2.9→4.5)</span>
                      </dd>
                      <dd className={styles.caseItem__layout__right__result__text}>
                        アプリ利用者が<span>10%</span>増加
                      </dd>
                      <dd className={styles.caseItem__layout__right__result__text}>
                        開発内製化に向けた確固たる土台を構築
                      </dd>
                    </dl>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className={styles.caseWrapper__two}>
            <div className={`${styles.caseItem} ${styles.item02}`}>
              <a href="/cases/heart-one/" className={styles.caseItem__link}>
                <p className={styles.caseItem__num}>Case 02</p>
                <div className={styles.caseItem__layout}>
                  <figure className={styles.caseItem__layout__left}>
                    <img
                      src="/img/LP/mobile-app-development/case02_daiwa.webp"
                      alt="新アプリ開発で顧客接点を一元化、グループ会社との連携も強化"
                    />
                  </figure>
                  <div className={styles.caseItem__layout__right}>
                    <p className={styles.caseItem__layout__right__tag}>金融業界</p>
                    <h2 className={styles.caseItem__layout__right__title}>
                      新アプリ開発で顧客接点を一元化、グループ会社との連携も強化
                    </h2>
                    <p className={styles.caseItem__layout__right__name}>大和ハウスフィナンシャル株式会社</p>
                  </div>
                </div>
              </a>
            </div>
            <div className={`${styles.caseItem} ${styles.item03}`}>
              <a href="/cases/gurutto-ai/" className={styles.caseItem__link}>
                <p className={styles.caseItem__num}>Case 03</p>
                <div className={styles.caseItem__layout}>
                  <figure className={styles.caseItem__layout__left}>
                    <img
                      src="/img/LP/mobile-app-development/case03_gurutto.webp"
                      alt="AI搭載アプリ開発で申し込み率改善、引越業務も効率化"
                    />
                  </figure>
                  <div className={styles.caseItem__layout__right}>
                    <p className={styles.caseItem__layout__right__tag}>引越・物流業界</p>
                    <h2 className={styles.caseItem__layout__right__title}>
                      AI搭載アプリ開発で申し込み率改善、引越業務も効率化
                    </h2>
                    <p className={styles.caseItem__layout__right__name}>アート引越センター株式会社</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <p className={styles.viewMore}>
          <a href="/cases/">もっと見る</a>
        </p>
      </div>
    </section>
  )
}
export default Case
